export default "<ng-container>\n  <ion-back-button (click)=\"back()\"></ion-back-button>\n</ng-container>";